import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Achievements.css";
import achieveImage from "../images/achieve.webp";

const Achievements = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <section className="about__achievments">
      <div className="container about__achievments-container">
        <div className="about__achievements-left" data-aos="fade-right">
          <img src={achieveImage} alt="Achievements" />
        </div>
        <div className="about__achievements-right" data-aos="fade-right">
          <h1>Our Achievements</h1>
          <p>
            JEE Vision Coaching has empowered countless students with a diverse
            range of courses. Our students consistently excel in competitive
            exams, securing top ranks. Recognized with numerous awards, our
            commitment to quality education and innovation is unwavering. Each
            achievement drives us to set higher benchmarks and impact our
            students' futures positively.
          </p>
          <div className="achievements__cards">
            <article className="achievement__card" data-aos="zoom-in">
              <span className="achievement__icon">
                <i className="fas fa-video"></i>
              </span>
              <h3>10+</h3>
              <p>Courses</p>
            </article>
            <article className="achievement__card" data-aos="zoom-in">
              <span className="achievement__icon">
                <i className="fas fa-users"></i>
              </span>
              <h3>2000+</h3>
              <p>Students</p>
            </article>
            <article className="achievement__card" data-aos="zoom-in">
              <span className="achievement__icon">
                <i className="fas fa-trophy"></i>
              </span>
              <h3>5+</h3>
              <p>Awards</p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
